import { useMemo } from 'react';
import useTenantConfigData from './useTenantConfigData';

const useTenantThemeApi = () => {
  const { theme, finishedLoading } = useTenantConfigData();

  const disclaimerData = useMemo(() => {
    if (!finishedLoading || !theme) {
      console.log('useTenantThemeApi: Not finished loading or no theme', { finishedLoading, theme });
      return { disclaimerText: null, environment: null, isToClose: false, bgColor: null };
    }

    try {
      let disclaimerText, environment, isToClose, bgColor;
      if (theme.disclaimerText && theme.disclaimerText.trim() !== '' && theme.disclaimerText !== 'NULL') {
        disclaimerText = theme.disclaimerText;
        environment = theme.environment;
        isToClose = theme.isToClose === 'true';
        bgColor = theme.bgColor;
      } else {
        disclaimerText = null;
        environment = null;
        isToClose = false;
        bgColor = null;
      }
      
      return { disclaimerText, environment, isToClose, bgColor };
    } catch (error) {
      return { disclaimerText: null, environment: null, isToClose: false, bgColor: null };
    }
  }, [theme, finishedLoading]);

  const showDisclaimer = disclaimerData.disclaimerText && 
    disclaimerData.disclaimerText.trim() !== '' && 
    disclaimerData.disclaimerText !== 'NULL';

  return {
    tenantThemeData: finishedLoading ? [theme] : [],
    disclaimerText: disclaimerData.disclaimerText,
    environment: disclaimerData.environment,
    isToClose: disclaimerData.isToClose,
    bgColor: disclaimerData.bgColor,
    showDisclaimer,
  };
};

export default useTenantThemeApi; 